export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="18"
  height="18"
  viewBox="0 0 18 18"
>
  <g
    transform="matrix(0.01757811,0,0,0.01757811,0,-1.757811e-5)"
  >
    <path
      d="m 418.909,0.001 h 186.183 q 19.549,0 33.047,13.498 13.498,13.498 13.498,33.047 v 325.819 h 325.819 q 19.549,0 33.047,13.498 13.498,13.498 13.498,33.047 v 186.183 q 0,19.549 -13.498,33.047 -13.498,13.498 -33.047,13.498 H 651.637 v 325.819 q 0,19.549 -13.498,33.047 -13.498,13.498 -33.047,13.498 H 418.909 q -19.549,0 -33.047,-13.498 -13.498,-13.498 -13.498,-33.047 V 651.638 H 46.545 q -19.549,0 -33.047,-13.498 Q 0,624.642 0,605.093 V 418.91 Q 0,399.361 13.498,385.863 26.996,372.365 46.545,372.365 H 372.364 V 46.546 q 0,-19.549 13.498,-33.047 Q 399.36,0.001 418.909,0.001 Z"
    />
  </g>
</svg>`;
